import { render, staticRenderFns } from "./send.vue?vue&type=template&id=5ca669b8&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca669b8')) {
      api.createRecord('5ca669b8', component.options)
    } else {
      api.reload('5ca669b8', component.options)
    }
    module.hot.accept("./send.vue?vue&type=template&id=5ca669b8&", function () {
      api.rerender('5ca669b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/send.vue"
export default component.exports